import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';
import { useUser } from '../UserContext'; // Adjust the import path as needed
import Pagination from './Pagination'; // Assuming you have a Pagination component
import { Link, useLocation } from 'react-router-dom';
import { buildUrlWithParams } from './utils.js'

const userTimeZone = moment.tz.guess(); 

const NotificationsPage = ({  }) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(parseInt(params.get('page'), 10) || 1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setCurrentPage(parseInt(params.get('page'), 10) || 1);
}, [location]);


//   const { user } = useUser();
  const { user, setUser, selectedCard, setSelectedCard, filters, setFilters } = useUser();

const onCardClick = (card) => {
    setSelectedCard(card);
}


  useEffect(() => {
    if (user) {
      fetchNotifications(currentPage);
    }
  }, [user, currentPage]);

  const fetchNotifications = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/users/notifications.php?userId=${user.userid}&page=${page}`);
      setNotifications(response.data.notifications);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching notifications:', error);
      setError('Failed to fetch notifications. Please try again later.');
      setLoading(false);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      await axios.post('/api/users/mark_notification_read.php', {
        notificationId,
        userId: user.userid
      });
      setNotifications(notifications.map(n => 
        n.id === notificationId ? {...n, is_read: true} : n
      ));
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const handleCardClick = (cardId) => {
    onCardClick(cardId);
  };

//   if (loading) {
//     return <div className="text-center mt-5"><div className="spinner-border" role="status"></div></div>;
//   }

  if (error) {
    return <div className="alert alert-danger mt-3" role="alert">{error}</div>;
  }

  const getNotificationTitle = (type) => {
    switch (type) {
        case 'comment':
            return 'New Comment';
        case 'reply':
            return 'New Reply';
        case 'ban':
            return 'Banned';
        case 'gallery':
            return 'Card in Gallery';
        case 'contest_theme_reminder':
            return 'Contest Winner';
        default:
            return 'Notification';
    }
  };


  return (
    <div className="container-fluid mt-4">
      <h2 className="mb-4">Notifications</h2>
      {notifications.length === 0 ? (
        <div className="alert alert-info" role="alert">No notifications to display.</div>
      ) : (
        <div>
{notifications.map((notification) => {
            const isContestReminder = notification.type === 'contest_theme_reminder';
            
            // Build the base parameters
            let urlParams = {
              ...Object.fromEntries(new URLSearchParams(window.location.search)),
              selectedCard: notification.card_id
            };

            // If a comment_id exists for this notification, append it to the URL
            if (notification.comment_id) {
              urlParams.commentId = notification.comment_id;
            }

            const linkTo = isContestReminder 
              ? `/gallery/contests/${notification.card_id}` 
              : buildUrlWithParams(urlParams);
              
            const imageUrl = isContestReminder 
              ? '/images/theme_alert.webp' 
              : `https://www.hearthcards.net/cards/${notification.cardid}.webp`;

            return (
              <div key={notification.id} className={`row mb-3 ${!notification.is_read ? 'border-primary' : ''} d-flex justify-content-between align-items-center`}>
                <div className="col-md-2 col-4">
                  <Link to={linkTo} style={{ textDecoration: 'none', zIndex: '2' }}>
                    <img src={imageUrl} className="img-fluid rounded-start" alt="Notification Visual" />
                  </Link>
                </div>
                <div className="col-md-10 col-8 text-start">
                  <div>
                    <h5 className="mb-1">
                      {!notification.is_read && <span className="badge bg-primary me-2">New</span>}
                      {getNotificationTitle(notification.type)}
                    </h5>
                    <p className="mb-1">{notification.content}</p>
                    <p className="mb-1">
                      <small className="text-muted">
                        {moment.utc(notification.created_at).tz(moment.tz.guess()).fromNow()}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;